// for search type toggle buttons:
import React from "react";

import colors from "core/colors";
import Icon from "core/ReusableIcons/Icon";
import Photo from "core/ReusableIcons/Photo";

export const searchTypeButtons = [
    {
        value: "Icons",
        icon: <Icon size="lg" fillColor={colors.secondary.oolong} />
    },
    {
        value: "Photos",
        icon: <Photo size="lg" fillColor={colors.secondary.oolong} />
    }
];

// placeholder text for search input:
export const heroSearchPlaceholderIcons = {
    desktop: "Search over 5 million icons",
    tablet: "Search over 5 million icons",
    mobile: "Search"
};

export const heroSearchPlaceholderPhotos = {
    desktop: "Search art-quality photos",
    tablet: "Search photos",
    mobile: "Search"
};
